import React from 'react';
import { useBrand } from '../../../app/config/brand';
import { Icons } from '../../../shared/icons/Icons';
import { Button } from '../../../shared/components/ui/Button';

interface PendingApprovalPageProps {
  user?: { name?: string; email?: string };
  onLogout: () => void;
}

const PendingApprovalPage: React.FC<PendingApprovalPageProps> = ({ user, onLogout }) => {
  const brand = useBrand();

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: brand.colors.bgLight }}>
      <div className="bg-white p-6 sm:p-12 rounded-xl shadow-lg max-w-md w-full text-center">
        <div className="w-14 sm:w-16 h-14 sm:h-16 rounded-full mx-auto mb-4 sm:mb-6 flex items-center justify-center" style={{ backgroundColor: brand.colors.warning + '20' }}>
          <Icons.Clock className="w-6 sm:w-8 h-6 sm:h-8" style={{ color: brand.colors.warning }} />
        </div>
        <h1 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4" style={{ color: brand.colors.secondary }}>Account Pending Approval</h1>
        <p className="mb-4 sm:mb-6 text-sm sm:text-base" style={{ color: brand.colors.textLight }}>
          Hi {user?.name || user?.email}, your account is awaiting administrator approval. You&apos;ll receive an email once your account has been activated.
        </p>
        <Button variant="secondary" onClick={onLogout}>Log out</Button>
      </div>
    </div>
  );
};

export default PendingApprovalPage;
